import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content-wrapper">
        <div className="hero-left">
          <div className="hero-content">
            <h1 className="hero-title">
              Invest in Tomorrow,
              <span className="hero-title-accent"> Today.</span>
            </h1>
            <p className="hero-subtitle">
              Strategic investment solutions across stock markets, real estate, technology startups, tax optimization strategies, heavy equipment leasing, and oil & gas exploration. Build wealth with confidence through our proven expertise.
            </p>
            <div className="hero-cta-group">
              <button onClick={scrollToContact} className="btn-primary">
                Schedule Consultation
                <ArrowRight size={20} />
              </button>
              <button onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })} className="btn-secondary">
                Explore Services
              </button>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-value-text">Multi Million Dollars</div>
                <div className="stat-label">Assets Under Management</div>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <div className="stat-value">15+</div>
                <div className="stat-label">Years of Excellence</div>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <div className="stat-value">98%</div>
                <div className="stat-label">Client Satisfaction</div>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-logo-container">
            <img src="/logo.jpg" alt="Infinity Capital Inc." className="hero-logo-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
